// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { passwordRequirementsValidatorStyles } from "@tps/App/Components/ResetPassword/PasswordRequirements";
import { color, getSystemColor } from "@tps/XDL/Utilities";
import { css } from "styled-components";

passwordRequirementsValidatorStyles.wrapper = {
    css: css`
        margin-bottom: 20px;
    `,
};

passwordRequirementsValidatorStyles.passwordRequirement = {
    css: css`
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 12px;
        color: ${({ passedRequirement, hasTyped }: any) =>
            !hasTyped ? color("text") : passedRequirement ? color("success") : color("danger")};
        display: flex;
        align-items: center;
        .icon {
            width: 12px;
            height: 12px;
            border: ${({ hasTyped }: any) => (hasTyped ? "0" : `1px solid ${getSystemColor("primary")}`)};
            border-radius: 50%;
            margin-right: 7px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `,
};
